import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

export default function RecipeReviewCard(props) {
  const {
    selectedValue,
    setSelectedValue,
    azurestate,
    setAzureState,
    setAzurefind,
  } = props;

  const [azurerolelist, setAzurerolelist] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/azureroleslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setAzurerolelist(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleRolesChange = (event) => {
    setAzurefind(true);
    setAzureState({ ...azurestate, [event.target.name]: event.target.checked });
  };

  return (
    <>
      <Card>
        <CardHeader
          avatar={
            <Radio
              checked={selectedValue === "b"}
              onChange={handleChange}
              value="b"
              name="radio-button-demo"
              inputProps={{ "aria-label": "B" }}
            />
          }
          title={<strong>Limited Access</strong>}
          subheader="Provides full access for selected resources"
        />
      </Card>
      {selectedValue === "b" ? (
        <Box sx={{ pt: 5 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Add Resources:</FormLabel>
            <Divider />
            <FormGroup>
              {azurerolelist.map((data) => {
                if (data.role !== "owner") {
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={azurestate[data.role]}
                          onChange={handleRolesChange}
                          name={data.role}
                        />
                      }
                      label={data.name}
                    />
                  );
                }
              })}
            </FormGroup>
          </FormControl>
        </Box>
      ) : (
        ""
      )}
    </>
  );
}
